/* Expand & Collapse Toggle */
export default function() {
  if (!document.querySelector('.js-expand')) {
    return;
  }

  const expandEls = document.querySelectorAll('.js-expand');

  /*
   * hideEls: elements that are hidden from screen readers upon expansion
   * triggerEl: element used to trigger the expand event & is disabled after click
   * toggleEl: element used to toggle between the expand/collapsed state
   * targetEl: element to show when expansion is triggered
   *
   * use either the triggerEl or toggleEl
   */
  expandEls.forEach(expandEl => {
    if (expandEl.classList.contains('is-async')) {
      return;
    }

    expandInit(expandEl);
  });
}

export function expandInit(expandEl) {
  const hideEls = expandEl.querySelectorAll('.js-expand-hide');
  const triggerEl = expandEl.querySelector('.js-expand-trigger');
  const toggleEl = expandEl.querySelector('.js-expand-toggle');
  const targetEl = expandEl.querySelector('.js-expand-target');

  // on click, reverse attribute sets
  if (toggleEl) {
    toggleEl.addEventListener('click', e => {
      e.preventDefault();
      const expanded = toggleEl.getAttribute('aria-expanded') == 'true';

      $(targetEl).slideToggle(300);
      expandEl.classList.toggle('is-open');

      toggleEl.setAttribute('aria-expanded', !expanded);
    });
  }

  if (triggerEl) {
    triggerEl.addEventListener('click', e => {
      e.preventDefault();

      $(targetEl).slideDown(300);
      expandEl.classList.add('is-open');
      triggerEl.setAttribute('aria-expanded', true);
      triggerEl.setAttribute('aria-disabled', true);
      targetEl.setAttribute('aria-hidden', false);
      hideEls.forEach(hideEl => hideEl.setAttribute('aria-hidden', true));
    });
  }
}
